import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../authentication/auth.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { PageFooterComponent } from "../page-footer/page-footer.component";
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-auth-param-handler-page',
  templateUrl: './auth-param-handler-page.component.html',
  styleUrls: ['./auth-param-handler-page.component.scss'],
  imports: [PageFooterComponent],
  standalone: true,
})
export class AuthParameterHandlerPageComponent implements OnInit, AfterViewInit {
  private mode: string;
  private oobCode: string;
  // private apiKey: string;
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);
  private loadingService = inject(LoadingService);
  private alertService = inject(AlertService);
  showMessage = {
    invalidUrl: false,
    emailVerificationError: false,
    unverifiedUserError: false,
    passwordResetSuccess: false,
    passwordResetError: false,
    passwordChangeSuccess: false,
    verificationEmailSuccess: false,
  };

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.mode = params['mode'];
      this.oobCode = params['oobCode'];
      // this.apiKey = params['apiKey'];

      switch (this.mode) {
        case 'resetPassword':
          this.auth.handleResetPassword(this.oobCode, this.showMessage);
          break;
        case 'recoverEmail':
          this.auth.handleRecoverEmail();
          break;
        case 'verifyEmail':
          this.auth.handleVerifyEmail(this.oobCode, this.showMessage);
          break;
        default:
          this.auth.handleInvalidURL(this.showMessage);
      }
    });
  }

  ngAfterViewInit(): void {
    this.loadingService.hide();
  }

  sendVerificationEmailAgain(): void {
    this.auth.sendVerificationEmailAgain(this.showMessage.verificationEmailSuccess);
  }

  updatePassword(newPassword: string): void {
    if(!newPassword) {
      this.alertService.showAlert({ message: 'New password is Require', title:'' });
      return;
    }
    this.auth.updatePassword(this.oobCode, newPassword, this.showMessage);
  }
}
